import { Box, Flex, Text } from '@chakra-ui/react';
import { Link, Logo } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/pro-regular-svg-icons';
import { useAuthRealm } from '../routes/AuthRealmAccessControl/AuthRealmContext';
import {
  COOKIE_SETTINGS_LINK_LABEL,
  PRIVACY_POLICY_URL
} from 'src/cookies/config';
import { useCookieConsent } from 'src/cookies/CookieConsentContext';
import { useState } from 'react';
import ContactUsProvider from 'src/pages/ContactUs/ContactUsProvider';
import HelpCenterDrawer from './HelpCenter/HelpCenterDrawer';

export const CopyrightFooter = () => (
  <Text textStyle="textContext">
    Copyright <FontAwesomeIcon size="sm" icon={faCopyright} />{' '}
    {new Date().getFullYear()} Molecular Connections Pvt. Ltd. | All Rights
    Reserved
  </Text>
);

const Footer = () => {
  const { clientBrand } = useAuthRealm();
  const { openPreferences, shouldShowConsentControls } = useCookieConsent();
  const [isOpen, setIsOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const APP_ENV = import.meta.env.VITE_APP_ENV;
  return (
    <Flex
      as="footer"
      py={{ base: 2, md: 3 }}
      px={{ base: 4, md: 6 }}
      justifyContent="space-between"
      alignItems={{ base: 'flex-start', lg: 'center' }}
      direction={{ base: 'column', lg: 'row' }}
      gap={{ base: 2, md: 4 }}
      wrap="wrap"
      bgColor="surfacePrimaryFill"
      borderTop="1px solid"
      borderColor="neutralPrimaryBorder"
    >
      {/* Left column: Logo + brand on top, copyright below */}
      <Flex direction="column" gap={1} alignItems="flex-start" flexShrink={0}>
        <Flex alignItems="center" gap={2} flexShrink={0}>
          <Logo
            src={clientBrand.logoUrl}
            maxWidth={{ base: '150px', sm: '220px', md: '280px' }}
            alt="Logo"
            maxH={{ base: '32px', sm: '40px', md: '48px' }}
          />
          <Box
            borderLeft="1px solid"
            borderColor="neutralPrimaryBorder"
            minH="24px"
            display={{ base: 'none', sm: 'block' }}
          />
          <Text textStyle="textContext" whiteSpace="nowrap">
            Journal Manager
          </Text>
        </Flex>
        <CopyrightFooter />
      </Flex>

      {/* Links section — right-aligned, won't shrink */}
      <Flex
        gap={{ base: 2, md: 3 }}
        textStyle="textContext"
        alignItems="center"
        justifyContent={{ base: 'flex-start', lg: 'flex-end' }}
        wrap="wrap"
        flexShrink={0}
      >
        {APP_ENV === 'staging' && (
          <Link
            href={`#`}
            variant="secondary"
            onClick={() => setIsHelpModalOpen(true)}
          >
            Help Center
          </Link>
        )}
        <Link variant="secondary" href={PRIVACY_POLICY_URL} target="_blank">
          Terms and Conditions
        </Link>
        <Link variant="secondary" href={PRIVACY_POLICY_URL} target="_blank">
          Privacy Policy
        </Link>
        <Link href={`#`} variant="secondary" onClick={() => setIsOpen(true)}>
          Contact Support
        </Link>
        {shouldShowConsentControls && (
          <Link variant="secondary" onClick={openPreferences}>
            {COOKIE_SETTINGS_LINK_LABEL}
          </Link>
        )}
      </Flex>
      {isOpen && (
        <ContactUsProvider
          isLoggedIn={true}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
      {isHelpModalOpen && (
        <HelpCenterDrawer
          isOpen={isHelpModalOpen}
          setIsOpen={setIsHelpModalOpen}
          isLoggedIn={true}
        />
      )}
    </Flex>
  );
};

export default Footer;
